module.exports = __webpack_public_path__ + "static/media/Brick Suit Boy.015e53f0.jpg";